'use strict';

angular.module('casist.ubytovanie')
  .controller('FakturaciaDlgCtrl', ['$scope', '$modalInstance', 'Dialog', '$q', function($scope, $modalInstance, Dialog, $q) {
    $scope.data = {
      mesiac: getCurrentDate(),
      datum: getCurrentDate()
    };

    $scope.ok = function() {
      $modalInstance.close($scope.data);
    };
    $scope.cancel = function() {
      $modalInstance.dismiss('cancelled');
    };
  }]);
